/**
 * Generate a Cloudinary URL with crop transformation based on stored crop position.
 * @param {string} url - Cloudinary image URL
 * @param {string} cropPosition - "top,bottom,left,right" percentages (e.g. "10,80,5,95")
 * @returns {string} - Cropped Cloudinary URL
 */
export function croppedCoverUrl(url, cropPosition) {
  if (!url || !url.includes('/upload/')) return url
  const c = cropPosition || '0,100,0,100'
  const [top, bottom, left, right] = c.split(',').map(Number)
  const t = (top || 0) / 100
  const b = (bottom || 100) / 100
  const l = (left || 0) / 100
  const r = (right || 100) / 100
  const w = r - l
  const h = b - t
  if (w >= 0.99 && h >= 0.99) return url
  const crop = `c_crop,w_${w.toFixed(2)},h_${h.toFixed(2)},x_${l.toFixed(2)},y_${t.toFixed(2)},fl_relative`
  return url.replace('/upload/', `/upload/${crop}/`)
}
